import { HttpClient, HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpService, isResultValid, translate } from 'src/app/main/http-service';
import { environment } from '../../environments/environment';
import { AppComponent } from '../app.component';
import { routes } from '../config/routes.config';
import { Icons } from '../handlers/icon.handler';
import { IconClass } from '../main/icon/icon.handler';
import { ButtonType } from '../main/modal/button.handler';
import { InitButton } from '../main/modal/modal.button';
import { ModalHandler } from '../main/modal/modal.handler';
import { Codes, Headers, addIcon, center } from '../main/table/table.handler';
import { IIconEvent } from '../main/table/table.interface';
import { translateHeaders } from '../main/table/table.translate';
import { IAppRelease, IPortalRelease } from '../medtracs-entities/releases/release-entity';

@Component({
   selector: 'app-download-release',
   templateUrl: './download-release.component.html',
   styleUrls: ['./download-release.component.css'],
})
export class DownloadReleaseComponent implements OnInit {
   private service: HttpService;

   appReleases: IAppRelease[] = [];

   portalReleases: IPortalRelease[] = [];

   icons = Icons;

   hideAppCardBody = false;

   hidePortalCardBody = false;

   canDownloadDocs = false;

   appHeaderStrings = [
      'Version',
      center('Android 32 bit (for older devices)'),
      center('Android 64 bit (for newer devices)'),
      center('Windows 32 bit'),
      center('Windows 64 bit'),
      center('Windows 32 bit .zip'),
      center('Windows 64 bit .zip'),
   ];

   appHeaders: Headers;

   appCodesStrings = [
      'version',
      center('armeabi'),
      center('arm64'),
      center('win32'),
      center('win64'),
      center('win32-zip'),
      center('win64-zip'),
   ];

   appCodes: Codes;

   portalHeaders = new Headers([
      'Version',
      center('Portal manual'),
      center('Validation documentation'),
   ]);

   portalCodes = new Codes(['version', center('portal'), center('validation')]);

   instantDownloadCode: string;

   progress = 0;

   progressBarType = environment.production ? '' : 'success';

   constructor(private http: HttpClient, public route: ActivatedRoute, public router: Router) {
      this.service = new HttpService(this.http, routes.docs);
      this.canDownloadDocs = AppComponent.session.user.canDownloadDocs;
      if (this.canDownloadDocs) {
         this.appHeaderStrings.push(center('Application manual'));
         this.appHeaderStrings.push(center('Validation documentation'));
         this.appCodesStrings.push(center('app'));
         this.appCodesStrings.push(center('validation'));
      }

      this.appCodes = new Codes(this.appCodesStrings);
      this.appHeaders = new Headers(this.appHeaderStrings);
      translateHeaders(this.appHeaders, translate);
      translateHeaders(this.portalHeaders, translate);
      route.queryParams.subscribe((query) => {
         this.instantDownloadCode = query?.code;
      });
   }

   ngOnInit(): void {
      this.get();
   }

   get(): void {
      const tooltip = translate('Download');
      this.service.post(
         {},
         (res: HttpResponse<{ appReleases: IAppRelease[]; portalReleases: IPortalRelease[] }>) => {
            if (isResultValid(res)) {
               this.appReleases = res.body.appReleases;
               this.portalReleases = res.body.portalReleases;
               addIcon(
                  this.appReleases,
                  'armeabi',
                  new IconClass(Icons.download, 'armeabi', [], tooltip),
                  ['armeabi'],
               );
               addIcon(
                  this.appReleases,
                  'arm64',
                  new IconClass(Icons.download, 'arm64', [], tooltip),
                  ['arm64'],
               );
               addIcon(
                  this.appReleases,
                  'win32',
                  new IconClass(Icons.download, 'win32', [], tooltip),
                  ['win32'],
               );
               addIcon(
                  this.appReleases,
                  'win64',
                  new IconClass(Icons.download, 'win64', [], tooltip),
                  ['win64'],
               );
               addIcon(
                  this.appReleases,
                  'win32-zip',
                  new IconClass(Icons.download, 'win32-zip', [], tooltip),
                  ['win32Zip'],
               );
               addIcon(
                  this.appReleases,
                  'win64-zip',
                  new IconClass(Icons.download, 'win64-zip', [], tooltip),
                  ['win64Zip'],
               );
               addIcon(
                  this.portalReleases,
                  'portal',
                  new IconClass(Icons.download, 'portal', [], tooltip),
                  ['portal'],
               );
               addIcon(
                  this.portalReleases,
                  'validation',
                  new IconClass(Icons.download, 'validation', [], tooltip),
                  ['validation'],
               );
               addIcon(this.appReleases, 'app', new IconClass(Icons.download, 'app', [], tooltip), [
                  'app',
               ]);
               addIcon(
                  this.appReleases,
                  'validation',
                  new IconClass(Icons.download, 'validation', [], tooltip),
                  ['validation'],
               );
            }
            if (this.instantDownloadCode) {
               this.service.download(
                  { code: this.instantDownloadCode, version: this.appReleases[0].version },
                  (progress) => {
                     this.progress = progress;
                  },
                  () => {
                     setTimeout(() => {
                        this.progress = 0;
                     }, 3000);
                  },
               );
               this.instantDownloadCode = undefined;
            }
         },
      );
   }

   onIconClick(event: IIconEvent<IAppRelease>): void {
      this.service.download(
         { code: event.id, version: event.row.version },
         (progress) => {
            this.progress = progress;
         },
         () => {
            setTimeout(() => {
               this.progress = 0;
            }, 3000);
         },
      );
   }

   changeHideAppReleases(): void {
      this.hideAppCardBody = !this.hideAppCardBody;
   }

   changeHidePortalReleases(): void {
      this.hidePortalCardBody = !this.hidePortalCardBody;
   }

   downloadDoc(code: string): void {
      this.service.download(
         { code },
         (progress) => {
            this.progress = progress;
         },
         () => {
            setTimeout(() => {
               this.progress = 0;
            }, 3000);
         },
      );
   }
}
